import { theme } from "../../../theme/theme";
const style = () => {
    const { colorIconActionOption, colorIconHighlight, borderWidth2, colorBgBase, colorBorderInteractive, borderRadiusFull, inputOptionSize, } = theme();
    return {
        checkbox: {
            alignItems: "center",
            borderRadius: borderRadiusFull,
            borderWidth: borderWidth2,
            height: inputOptionSize,
            justifyContent: "center",
            width: inputOptionSize,
        },
        icon: {
            color: colorIconActionOption,
        },
        colorBgBase,
        colorIconHighlight,
        colorBorderInteractive,
    };
};
export { style };
